import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import io from 'socket.io-client';
import backendUrls from './config/backendUrls.js';
import LoginPage from './components/auth/LoginPage.js';
import AdminLayout from './components/admin/AdminLayout.js';
import BranchManagerLayout from './components/branch/BranchManagerLayout.js';
import StaffLayout from './components/staff/StaffLayout.js';
import ProtectedRoute from './components/common/ProtectedRoute.js';
import useAppStore from './store/useAppStore.js';
import './App.css';

function App() {
  const token = useAppStore(state => state.token);
  const offlineMode = useAppStore(state => state.offlineMode);
  const login = useAppStore(state => state.login);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUserJson = localStorage.getItem('user');

    if (token && storedUserJson && !useAppStore.getState().token) {
      try {
        const user = JSON.parse(storedUserJson);
        if (user && user.role) {
          login(user, user.role, token);
        }
      } catch (error) {
        console.error('Failed to restore auth state from localStorage:', error);
      }
    }
  }, [login]);

  useEffect(() => {
    if (!token || offlineMode) {
      return;
    }

    const socketUrl = backendUrls.SOCKET_URL;
    const socket = io(socketUrl, {
      auth: {
        token
      }
    });

    socket.on('token_issued', (data) => {
      // Keep socket alive for real-time updates without system notifications
    });

    socket.on('token_event', (data) => {
      // Keep socket alive for real-time updates without system notifications
    });

    return () => {
      socket.disconnect();
    };
  }, [token, offlineMode]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/admin/*" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>} />
        <Route path="/branch-manager/*" element={<ProtectedRoute role="manager"><BranchManagerLayout /></ProtectedRoute>} />
        <Route path="/staff/*" element={<ProtectedRoute role="staff"><StaffLayout /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
